import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	center: {
		textAlign: 'center' as const,
	},
	td: {
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.xs,
		padding: '14px 10px',
		verticalAlign: 'middle' as const,
	},
	tdTruncate: {
		maxWidth: 0,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap' as const,
	},
	jobIdCell: {
		alignItems: 'center',
		display: 'flex',
	},
	copy: {
		cursor: 'pointer',
		paddingLeft: THEME.spacing.sm,
	},
	/** Reverted rows are clickable to expand details */
	revertedRow: {
		cursor: 'pointer',
		':hover': {
			background: THEME.colors.background.main,
		},
	},
	/** Status badge — shared base */
	badge: {
		borderRadius: THEME.common.borderRadius,
		display: 'inline-flex',
		alignItems: 'center',
		fontSize: THEME.typography.fontSizes.xxs,
		fontWeight: THEME.typography.fontWeights.bold,
		gap: 6,
		padding: '3px 10px',
		whiteSpace: 'nowrap' as const,
	},
	badgeClean: {
		background: THEME.colors.success.light,
		color: THEME.colors.success.dark,
	},
	badgeWarning: {
		background: THEME.colors.warning.light,
		color: THEME.colors.warning.dark,
	},
	chevron: {
		display: 'inline-block',
		fontSize: THEME.typography.fontSizes.xxs,
		marginRight: 6,
		transition: 'transform 150ms ease',
	},
	chevronExpanded: {
		transform: 'rotate(90deg)',
	},
	/** Expandable detail row */
	detailTd: {
		background: THEME.colors.background.main,
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		padding: '12px 20px',
	},
	detailGrid: {
		display: 'grid',
		gap: THEME.spacing.lg,
		gridTemplateColumns: '1fr 1fr',
	},
	detailSection: {},
	detailSectionTitle: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.xxs,
		fontWeight: THEME.typography.fontWeights.bold,
		letterSpacing: 0.5,
		marginBottom: THEME.spacing.sm,
		textTransform: 'uppercase' as const,
	},
	detailList: {
		listStyle: 'none',
		margin: 0,
		padding: 0,
	},
	detailItem: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.xs,
		lineHeight: '20px',
	},
	detailCount: {
		fontWeight: THEME.typography.fontWeights.bold,
	},
	detailCountWarning: {
		color: THEME.colors.danger.main,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	detailFooter: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: THEME.spacing.sm,
	},
	detailLink: {
		height: 'auto',
		fontSize: THEME.typography.fontSizes.xs,
		padding: 0,
	},
	fileNameLink: {
		display: 'inline-block',
		height: 'auto',
		fontSize: 'inherit',
		maxWidth: '100%',
		overflow: 'hidden',
		padding: 0,
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap' as const,
	},
	/** Status cell wrapper — holds badge + chevron together */
	statusCell: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.xs,
	},
});
